const F = {
  app_sub: "Sistema ng Pamamahala ng Pananalapi ng GKK at Unit",
  record_collection: "Itala ang Koleksiyon",
  record_expense: "Itala ang Gastos",
  view_report: "Tingnan ang Ulat Pampinansyal",
  special_collections: "Mga Espesyal na Koleksiyon",
  remittances: "Mga Remittance / Pagpasa ng Pera",
  monthly_dues: "Buwanang Hulog",
  dashboard: "Dashboard ng Pananalapi",
  download_reports: "I-download ang mga Ulat",
  request_correction: "Humiling ng Pagwawasto",
  admin_panel: "Panel ng Administrador",
  search: "Maghanap ng Tala",
  unit_roster: "Listahan ng mga Ingat-yaman ng Unit",
  my_reports: "Aking mga Ulat ng Koleksiyon",
  login: "Mag-sign in",
  username: "Username",
  password: "Password",
  logout: "Mag-sign out",
  home: "Home",
  save_draft: "I-save ang Draft",
  review_entry: "Suriin ang Tala",
  submit_final: "Isumite ang Pinal na Ulat",
  where_when: "Saan at kailan",
  amounts: "Mga halagang nakolekta",
  people_cert: "Pagbibilang at sertipikasyon",
  gkk: "GKK",
  unit: "Unit",
  gkk_level: "Antas ng GKK (hindi Unit)",
  report_type: "Ano ang nangyari?",
  rt_collection: "May koleksiyon",
  rt_no_collection: "Walang koleksiyon",
  rt_service_canceled: "Hindi natuloy ang serbisyo",
  occasion: "Uri ng gawain",
  date_collection: "Petsa ng koleksiyon",
  start_time: "Oras ng simula",
  end_time: "Oras ng pagtatapos",
  counted_at: "Oras ng pagbilang ng pera",
  location: "Lugar / Purok",
  venue: "Pook (kapilya, bahay, atbp.)",
  add_line: "Magdagdag ng koleksiyon",
  category: "Uri ng koleksiyon",
  amount: "Halaga (₱)",
  total: "Kabuuan",
  denom_counter: "Bilangin ang papel at barya (opsiyonal)",
  declared_total: "Kabuuang binilang mo nang mano-mano (opsiyonal)",
  treasurer_name: "Pangalan ng Ingat-yaman / Kolektor",
  position: "Posisyon",
  witness: "Ikalawang nagbilang / saksi",
  custodian: "Taong may hawak ng pera (kung iba)",
  certify: "Pinatutunayan ko na ang koleksiyon at impormasyong pampinansyal sa ulat na ito ay personal kong binilang o sinuri at ito ay totoo, kumpleto, at tama ayon sa aking kaalaman.",
  review_warning: "Pakisuring mabuti ang lahat ng halaga at detalye. Kapag naisumite, mala-lock ang ulat na ito. Ang anumang pagwawasto ay kailangang aprubahan ng Administrador ng Parokya.",
  back_edit: "Bumalik at baguhin",
  confirm_submit: "Oo, isumite at i-lock",
  offline_banner: "Wala kang internet. Maaari kang mag-save ng draft sa teleponong ito; ia-upload ito pagbalik ng internet. Ang offline na draft ay HINDI pa opisyal na pagsusumite.",
  saved_locally: "Naka-save sa teleponong ito lamang",
  status_draft: "Draft",
  status_submitted: "Naisumite",
  status_pending_verification: "Sinusuri Pa",
  status_verified: "Napatunayan",
  status_rejected: "Ibinalik para Iwasto",
  status_finalized: "Pinal na",
  status_approved: "Naaprubahan",
  status_paid: "Nabayaran",
  status_cancelled: "Kinansela",
  status_pending: "Naghihintay",
  status_info_requested: "Humiling ng Dagdag na Impormasyon",
  status_reported: "Naiulat Na",
  status_no_collection: "Walang Koleksiyon",
  status_service_canceled: "Hindi Natuloy",
  status_not_yet_reported: "Hindi Pa Naiulat",
  regular: "Regular",
  special: "Espesyal (nakalaan)",
  other: "Iba pang natanggap",
  not_yet_reported: "Hindi pa naiulat",
  notifications: "Mga Abiso",
  mark_all_read: "Markahang nabasa lahat",
  public_page: "Pampublikong buod ng transparency",
  welcome: "Maligayang pagdating sa GKK Financial Management Information System. Ang plataporma na ito ay nagbibigay sa mga awtorisadong opisyal ng GKK at Unit ng ligtas na paraan ng pagtatala, pagrepaso, pagpapatunay, at pagsubaybay sa mga koleksiyon, remittance, gastos, at iba pang transaksiyong pampinansyal.",
  notice_only: "Ang mga opisyal na kinikilalang opisyal ng GKK at Unit lamang ang maaaring magparehistro para sa administratibo o pampinansyal na access. Lahat ng rehistro ay sasailalim sa pagpapatunay at pag-apruba ng Administrador ng Parokya.",
  google_btn: "Mag-sign in gamit ang Google",
  email_login: "Mag-log in gamit ang Email at Password",
  register_btn: "Magparehistro bilang Opisyal ng GKK/Unit",
  forgot: "Nakalimutan ang Password?",
  check_status: "Tingnan ang Status ng Rehistro",
  contact_admin: "Kontakin ang Administrador ng Parokya",
  email: "Nakarehistrong email address",
  remember_email: "Tandaan ang email",
  show: "Ipakita",
  hide: "Itago",
  announcements: "Mga Anunsiyo",
};
export default F;
